import { render, staticRenderFns } from "./winloss_subag.vue?vue&type=template&id=24e46f08&scoped=true&"
import script from "./winloss_subag.vue?vue&type=script&lang=js&"
export * from "./winloss_subag.vue?vue&type=script&lang=js&"
import style0 from "./winloss_subag.vue?vue&type=style&index=0&id=24e46f08&scoped=true&lang=css&"
import style1 from "./winloss_subag.vue?vue&type=style&index=1&id=24e46f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e46f08",
  null
  
)

export default component.exports